//Generated File 
export default class ListDisplayType{
	static readonly Chips = `Chips`;
	static readonly Default = `Default`;
	static readonly Dropdown = `Dropdown`;
}
